import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  WORKINGTIME_DEFAULT_SORT_ORDER,
  WORKINGTIME_DEFAULT_SORT_COLUMN,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface WorkingtimeGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  employeeId: number | null;
  date: string | null;
}

export const DefaultWorkingtimeGetQueryParams: WorkingtimeGetQueryParams = {
  page: DEFAULT_PAGE,
  sortOrder: WORKINGTIME_DEFAULT_SORT_ORDER,
  sortKey: WORKINGTIME_DEFAULT_SORT_COLUMN,
  employeeId: null,
  date: null,
};
